/**
 * Steps data for OnboardingPDF component
 * Contains tour steps and related methods
 */

export const stepsData = {
  steps: [
    {
      target: '.sop-header h1',
      content: 'This is the title of your onboarding document.',
      placement: 'bottom'
    },
    {
      target: '.description p',
      content: 'This is the description of your onboarding.',
      placement: 'bottom'
    },
    {
      target: '[data-type="draggable-item"]:first-child',
      content: 'Each step in your onboarding is displayed here.',
      placement: 'right'
    },
    {
      target: '#menu-dropdown',
      content: 'Click here to access various options like downloading PDF, sharing, or editing.',
      placement: 'left'
    },
    {
      target: '#btn-complete',
      content: 'Click this button when you have completed the onboarding to mark it as finished.',
      placement: 'top'
    }
  ],
  
  methods: {
    ShowTour() {
      this.InTour = true;
    },
    OpenAddCommentToStepMenu(container) {
      this.tempStepId = container.closest('[data-step-id]')?.getAttribute('data-step-id') || '';
      this.InAddingCommentToStepMode = true;
    }
  }
};

export default stepsData;
